import Download from './Download.js';

export default Download;
